import { FC, useEffect, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import { Modal } from 'react-bootstrap-v5'
import { GuestCard } from './GuestCard'
import { ExperienceSummary } from '../../teamExperiences/models/ExperienceSummaryModel'
import { GuestStatus } from '../models/GuestStatus'
import { getGuestsExperiences } from '../../../services/teamExperienceService'
import { getMaxPeople } from '../../experienceHostPreview/components/utils'

interface Props {
  show: boolean,
  onClose: () => void,
  experience?: any,
  onLoad?: (isloaded: boolean) => void;
}

export const GuestsModal: FC<Props> = ({ show, onClose, onLoad, experience }) => {
  const [users, setUsers] = useState<any[]>([]);
  const [confirmed, setConfirmed] = useState<any[]>([]);
  const [pendingPayment, setPendingPayment] = useState<any[]>([]);
  const [pendingInvitation, setPendingInvitation] = useState<any[]>([]);
  const [summary, setSummary] = useState<any>({});

  useEffect(() => {
      const fetchData = async () => {
          await getList();
      }
      fetchData();
  },[])

  const getList = async () => {
      onLoad(true);
      const guests = await getGuestsExperiences(experience.id);
      setConfirmed(guests?.confirmedPayment ?? []);
      setPendingPayment(guests?.confirmedAttendance);
      setPendingInvitation(guests?.pendingAttendanceConfirmation ?? []);
      setSummary(guests?.summary);
      onLoad(false);
  }

  if (!show) return null

  return (<Modal show={show} onHide={onClose} centered backdrop="static" dialogClassName='experience-user-guests'>
    {/* <div className="experience-user-guests-modal__overlay"> */}
    <div className="experience-user-guests-modal">
      {/* Close */}
      <button className="experience-user-guests-modal__close" onClick={onClose} aria-label="Close">
        <KTSVG path='/media/svg/nobilis/closeX.svg' />
      </button>

      {/* Header */}
      <div className="experience-user-guests-modal__header">
        <h2>Confirmed Guests</h2>
        <div className="experience-user-guests-modal__counter">
          <span>{summary.totalGuests} / {getMaxPeople(experience)} guests</span>
        </div>
      </div>

      {/* Confirmed guests */}
      <div className="experience-user-guests-modal__section">
        {(confirmed ?? []).map((user:any,index:number)=>{
          return (<GuestCard key={index} user={user} status={GuestStatus.CONFIRMED} />);
        })}
      </div>

      {/* Pending payments */}
      <div className="experience-user-guests-modal__section-title">
        Pending payments
      </div>

      <div className="experience-user-guests-modal__section">
        {(pendingPayment ?? []).map((user:any,index:number)=>{
          return (<GuestCard key={index} user={user} status={GuestStatus.PENDING_PAYMENT} />);
        })}
      </div>

      {/* Pending invitations */}
      <div className="experience-user-guests-modal__section-title">
        Pending invitations
      </div>

      <div className="experience-user-guests-modal__section">
        {(pendingInvitation ?? []).map((user:any,index:number)=>{
          return (<GuestCard key={index} user={user} status={GuestStatus.PENDING_INVITATION} />);
        })}
      </div>
    </div>
    {/* </div> */}
  </Modal>)
}
